import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getAssetsList(filters) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: 'v2/assets/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params: filters });
      const { items, total } = processSuccessResponse(res);

      return { items, total };
    } catch (e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getAssetDetails(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/assets/${id}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);
      const data = processSuccessResponse(res);

      return data;
    } catch (e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async updateAsset(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/assets/${id}/`,
      method: HttpMethod.PUT
    };

    try {
      const res = await processRequest(ep, { data });
      const asset = processSuccessResponse(res);

      return asset;
    } catch (e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
